import { useReveal } from '../hooks/useReveal';

/**
 * Wrapper that fades/slides its children up once scrolled into view.
 * `delay` staggers grouped children (ms).
 */
const Reveal = ({ as: Tag = 'div', className = '', delay = 0, children, ...rest }) => {
  const { ref, visible } = useReveal();

  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
